export default __webpack_public_path__ + "static/media/Panchami3.b5e5c16d.png";